module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "plm_hd"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_genpref"
    }
  }, [_vm._v("General preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_autpref"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_abbrev"
    }
  }, [_vm._v("Chief abbreviations")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_abbrev#sigil_toc_id_1"
    }
  }, [_vm._v("Bible versions")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_bibliog"
    }
  }, [_vm._v("Select bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_J_intro"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("JOEL")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_J_intro#sigil_toc_id_2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_J_intro#sigil_toc_id_3"
    }
  }, [_vm._v("1. Structural patterns in the book of Joel")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_J_intro#sigil_toc_id_4"
    }
  }, [_vm._v("2. The date of the book")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_J_intro#sigil_toc_id_5"
    }
  }, [_vm._v("3. Joel and the ‘Book of the Twelve’")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_J_intro#sigil_toc_id_6"
    }
  }, [_vm._v("4. Joel and intertextuality")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_J_intro#sigil_toc_id_7"
    }
  }, [_vm._v("5. The setting and genre of the book")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_J_intro#sigil_toc_id_8"
    }
  }, [_vm._v("6. The message of Joel")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_J_anal",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Analysis")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_J_ch01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Commentary")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_J_ch01#sigil_toc_id_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Introduction (1:1)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_J_ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. God’s grace during past crises (1:2 – 2:27)")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_J_ch02#sigil_toc_id_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The first call to lament (1:2–20)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_J_ch02#sigil_toc_id_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The second call to lament (2:1–17)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_J_ch02#sigil_toc_id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. The Lord’s response (2:18–27)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_J_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. God’s grace in the crisis to come (2:28 – 3:21 ["), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("mt")]), _vm._v(" 3:1 – 4:21])")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_J_ch03#sigil_toc_id_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The outpouring of the spirit (2:28–32 ["), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("mt")]), _vm._v(" 3:1–5])")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_J_ch03#sigil_toc_id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The crimes and judgment of the nations (3:1–8 ["), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("mt")]), _vm._v(" 4:1–8])")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_J_ch03#sigil_toc_id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. The last battle (3:9–21 ["), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("mt")]), _vm._v(" 4:9–21])")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_amos_intro",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AMOS")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_amos_intro#sigil_toc_id_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_amos_intro#sigil_toc_id_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The book of Amos as a work of literature")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_amos_intro#sigil_toc_id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Amos the prophet")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_amos_intro#sigil_toc_id_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The political and social context of Amos’s preaching")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_amos_intro#sigil_toc_id_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Interpreting the book of Amos")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_amos_intro#sigil_toc_id_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Theology and ethics in Amos")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_anal",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Analysis")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Commentary")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch01#sigil_toc_id_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Introduction (1:1–2)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Israel has become like the nations (1:3 – 2:16)")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch02#sigil_toc_id_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Oracles against foreign nations (1:3 – 2:3)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch02#sigil_toc_id_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Oracles against Israel and Judah (2:4–16)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A divine word against the people of Israel (3:1 – 4:13)")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch03#sigil_toc_id_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The lion has roared: fear for your lives (3:1–8)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch03#sigil_toc_id_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Israel’s transgressions on Mount Samaria and at the Bethel altar (3:9 – 4:3)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch03#sigil_toc_id_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Israel’s transgressions in Bethel: lack of repentance (4:4–13)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. A prophetic word against the house of Israel (5:1 – 6:14)")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch04#sigil_toc_id_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Injustice, seeking the Lord, death (5:1–17)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch04#sigil_toc_id_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The Day of the Lord and Israel’s corrupt worship (5:18–27)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch04#sigil_toc_id_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Israel’s current prosperity and future failures (6:1–14)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The inevitable destruction of IsraeL (7:1 – 9:6)")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch05#sigil_toc_id_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The first two visions: the Lord relents (7:1–6)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch05#sigil_toc_id_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The third vision: the plumb line (7:7–17)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch05#sigil_toc_id_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. The fourth vision: the end has come (8:1–14)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch05#sigil_toc_id_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. The fifth vision: the destroyed temple (9:1–6)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_A_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The raising of the fallen Booth of David (9:7–15)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for the Tyndale Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tyndale Commentaries from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/JA_imprint",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fd06652","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/JA_contents.vue
// module id = 60
// module chunks = 0